import React from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import DriverShipmentUnLoadingForm from "./ShipmentUnLoadingComponents/DriverShipmentUnLoadingForm";
import { useAppMeta } from "hooks";
import { useAddShipmentUnloadingForDriverMutation } from "store/services/shipmentUnLoadingApi";

const DriverShipmentUnLoadingCreateScreen = () => {
    const navigate = useNavigate();
    const breadcrumbs = [
        { title: "Shipment Unloading", path: "/app/driver/unloading" },
        { title: "New Shipment Unloading For Driver" }
    ];

    const [createShipmentUnLoading, { isLoading: creatingShipmentUnLoading }] =
        useAddShipmentUnloadingForDriverMutation();

    // methods
    const handleAddSShipmentUnLoading = async (data) => {
        try {
            const response = await createShipmentUnLoading(data).unwrap();
            const records = response?.records || [];
            const _id = records[0]?.unloading?._id;
            toast.success(
                records.length > 1
                    ? "Shipment Unloading Created! (2 records — delivered and transit)"
                    : "Shipment Unloading Created!"
            );
            navigate(`/app/driver/unloading/${_id}/detail`);
        } catch (error) {
            toast.error(
                error?.data?.message ?? error.message ?? "Could Not Created Shipment Unloading!"
            );
        }
    }

    useAppMeta("New Shipment Unloading");

    return (
        <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingShipmentUnLoading}>
            <BreadcrumbLayout.Paper>
                <DriverShipmentUnLoadingForm
                    isBusy={creatingShipmentUnLoading}
                    onSubmit={handleAddSShipmentUnLoading}
                />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    )
}

export default DriverShipmentUnLoadingCreateScreen